import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { AppConstants } from '../_constants/constants';

@Injectable()
export class SellerProfileIncompleteGuard implements CanActivate {

    constructor(private router: Router, @Inject(PLATFORM_ID) private platformId: Object) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // Check if we're in browser environment
        const isBrowser = typeof window !== 'undefined' && typeof localStorage !== 'undefined';

        // For SSR: Allow access (server can't check localStorage)
        // Client-side auth check will happen after hydration
        if (!isBrowser) {
            return true;
        }

        const currentUserJson = localStorage.getItem(AppConstants.CURRENT_USER_KEY);
        const currentUser = currentUserJson ? JSON.parse(currentUserJson) : null;

        // Allow access to all users - profile completion is now optional
        // A banner will be shown in the dashboard if seller profile is incomplete
        return true;
    }
}
